import type { DummyTrainSkill } from '../data/armas';
import { t } from '../i18n/idioma';
import { nomeDaSkill } from '../i18n/nomes';
import { ItemIcon } from './ItemIcon';
import { MenuRadial, type BotaoRadial } from './MenuRadial';

/** As skills do manequim e a arma que representa cada uma (as mesmas do Treinar do topo). */
const SKILLS: ReadonlyArray<{ skill: DummyTrainSkill; icone: string; imagem?: string }> = [
  { skill: 'swordsmanship', icone: 'katana' },
  { skill: 'maceFighting', icone: 'gnarled-staff' },
  { skill: 'fencing', icone: 'dagger' },
  { skill: 'axing', icone: 'large-battle-axe' },
  { skill: 'magery', icone: 'spellbook', imagem: '/sprites/itens/hud/spellbook.png' }
];

interface Props {
  dummyId: number;
  x: number;
  y: number;
  /** O bônus do boneco da casa, pronto para o rodapé do título (techspec-marceneiro-e-oficios-em-casa §06). */
  bonus?: string;
  onPick(dummyId: number, skill: DummyTrainSkill): void;
  onClose(): void;
}

/** O menu do manequim de treino: o anel, como o do jogador (Renato, 03/11/2026). Escolhida a skill, o pergaminho abre. */
export function DummyMenu({ dummyId, x, y, bonus, onPick, onClose }: Props) {
  const botoes: BotaoRadial[] = SKILLS.map(s => ({
    id: s.skill,
    rotulo: nomeDaSkill(s.skill),
    icone: (
      <i className="pm-radial__ic">
        {s.imagem
          ? <img src={s.imagem} alt="" width={26} height={26} draggable={false} />
          : <ItemIcon id={s.icone} label="" size={26} />}
      </i>
    ),
    onClick: () => onPick(dummyId, s.skill)
  }));
  return <MenuRadial titulo={t('manequim.treinoTitulo')} sub={bonus} x={x} y={y} botoes={botoes} onClose={onClose} />;
}
